import { ReactNode } from 'react';

import {
  TelegramIconHeader,
  YoutubeIconHeader,
} from '@constants/common/icons.constants';
import { TELEGRAM_LINK, YOUTUBE_LINK } from '@constants/common/links.constants';

type SocialItem = {
  title: string;
  path: string;
  icon: ReactNode;
  disabled?: boolean;
};

export const SOCIAL_LINKS: SocialItem[] = [
  // {
  //   title: 'X',
  //   path: TWITTER_LINK,
  //   icon: TwitterIconHeader,
  // },
  // {
  //   title: 'Instagram',
  //   path: INSTAGRAM_LINK,
  //   icon: InstagramIconHeader,
  // },
  // {
  //   title: 'Facebook',
  //   path: FACEBOOK_LINK,
  //   icon: FacebookIconHeader,
  // },
  // {
  //   title: 'TikTok',
  //   path: TIKTOK_LINK,
  //   icon: TikTokIconHeader,
  // },
  {
    title: 'Youtube',
    path: YOUTUBE_LINK,
    icon: YoutubeIconHeader,
  },
  {
    title: 'Telegram',
    path: TELEGRAM_LINK,
    icon: TelegramIconHeader,
  },
];
